import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { EmailServicesService } from 'src/app/services/email-services.service';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { JobServicesService } from 'src/app/services/job-services.service';
import { EventServicesService } from 'src/app/services/event-services.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-workflow-manage-schedule',
    templateUrl: './workflow-manage-schedule.component.html',
    styleUrls: ['./workflow-manage-schedule.component.css'],
    providers: [MessageService, DatePipe],
    standalone: false
})
export class WorkflowManageScheduleComponent implements OnInit {

  @Input() stage: any;
  @Input() eventStageFormData: any;
  
  EmailTemplateOptions: any[] = [];
  @Output() isTestSelected = new EventEmitter<any>();
  @Output() isFeedbackSelected = new EventEmitter<any>();
  @Output() emitTestId = new EventEmitter<any>();
  @Output() emitContestId = new EventEmitter<any>();
  @Output() isStageUpdate = new EventEmitter<boolean>();

  showSummary: boolean = false;
  isInEvent: boolean = false;
  showMailSummary: boolean = false;
  manageTemplateLoad: boolean = false;
  manageContentLoad: boolean = false;
  contestList: Array<any> = [];
  formsList: Array<any> = [];
  documentationForms: Array<any> = [];
  feedbackForms: Array<any> = [];
  offerForms: Array<any> = [];
  testForms: Array<any> = [];
  errorPlaceholder: any = [];
  selectedMailTemplate: any = {};
  savedSchedule: any;
  savedTemplateTitle: any;
  selectedContest: any = null;
  isWalkIn: boolean = false;
  selectedForm: any = null;
  userPrivileges: Set<string> = new Set();
  selectedMailTemplateId: any;
  scheduledBy: string = '';
  testSource: string = '';
  timelimit: number = 0;
  testId: string = '';
  contestName: string = '';
  testName: string = '';
  formName: string = '';
  jobId: string = '';
  eventId: string = ''
  eventName: string = '';
  jobName: string = '';
  schoolCode: string = '';
  testDuration: string = '';
  dateFormat: string = '';
  
  evaluationCriteria: string = '';
  agents: Array<{ label: string, value: string }> = [];
  selectedAgent: any = null;
  agentsLoading: boolean = false;
  showFormDialog: boolean = false;
  showEmailDialog: boolean = false;

  constructor(private jobServices: JobServicesService, private router: Router, private messageService: MessageService, private globalService: GlobalServicesService, private emailServices: EmailServicesService, private eventServices: EventServicesService, private activatedRoute: ActivatedRoute, private datePipe: DatePipe) {
    this.schoolCode = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_details?.subdomain : '';
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';
    this.activatedRoute.paramMap.subscribe(params => {
      this.eventId = params.get('eventId') || '';
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {    
    if (changes['eventStageFormData'] && this.eventStageFormData) {
      this.testForms = this.eventStageFormData.testForms;
      this.feedbackForms = this.eventStageFormData.feedbackForms;
      this.documentationForms = this.eventStageFormData.documentationForms;
      this.offerForms = this.eventStageFormData.offerForms;

      if ((this.eventStageFormData) && (this.stage)) {
        if (this.stage.type === 'Assessment' && this.stage.contest?.uuid) {
          this.contestName = this.testForms.filter((form) => form.value === this.stage.contest.uuid)[0]?.label;
        } else if ((this.stage.type === 'Online Interview' || this.stage.type === 'Offline Interview' || this.stage.type === 'AI Interview') && this.stage.form?.uuid) {
          this.formName = this.feedbackForms.filter((form) => form.value === this.stage.form.uuid)[0]?.label;
        } else if (this.stage.type === 'Documentation' && this.stage.form?.uuid) {
          this.formName = this.documentationForms.filter((form) => form.value === this.stage.form.uuid)[0]?.label;
        } else if (this.stage.type === 'Offer' && this.stage.form?.uuid) {
          this.formName = this.offerForms.filter((form) => form.value === this.stage.form.uuid)[0]?.label;
        }
      }
    }
    
    if (changes['stage'] && this.stage) {
      this.isWalkIn = !!this.stage.is_walk_in;
      this.initializeFromStage();
    }
  }
  
  async ngOnInit() {
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    this.jobName = window.localStorage.getItem("selectedJobName") || '';
    this.eventName = window.localStorage.getItem("selectedEventName") || '';
    this.isInEvent = this.jobId === this.eventId;
    if(this.stage.type === 'Assessment'){
      this.showSummary = this.stage.contest?.uuid? true : false;
      this.contestName = this.stage.contest?.name;
      this.isWalkIn = !!this.stage.is_walk_in;
    } else if (this.stage.type === 'Online Interview' || this.stage.type === 'Documentation' || this.stage.type === 'Offer' || this.stage.type === 'Offline Interview' || this.stage.type === 'AI Interview') {
      this.showSummary = this.stage.form?.uuid ? true : false;
      this.formName = this.stage.form?.name
    }
    this.showMailSummary = this.stage.email_template?.id? true : false;
    if (this.showMailSummary) {
      this.selectedMailTemplate ={
      templateContent:"-",
      templateTitle: this.stage.email_template.name,
      };
    }
    
    this.initializeFromStage();
  }
  
  initializeFromStage() {
    this.evaluationCriteria = this.stage.evaluation_criteria || '';
    
    if (this.stage.type === 'AI Interview') {
      this.selectedAgent = this.stage.ai_agent_uuid || null;
      this.loadAgents();
    }
  }
  
  loadAgents() {
    if (this.agents.length > 0 || this.agentsLoading) {
      return;
    }
    this.agentsLoading = true;
    this.eventServices.getAgentsFastApi().subscribe({
      next: (response) => {
        if (response.status === 200 && response.body?.result) {
          this.agents = response.body.result.map((agent: any) => ({
            label: agent.name,
            value: agent.id
          }));
        }
        this.agentsLoading = false;
      },
      error: (err) => {
        console.error('Error loading agents:', err);
        this.agentsLoading = false;
      }
    });
  }
  
  // Get agent name for display
  getAgentName(): string {
    const agentUuid = this.selectedAgent || this.stage?.ai_agent_uuid;
    if (agentUuid && this.agents.length > 0) {
      const agent = this.agents.find(a => a.value === agentUuid);
      return agent ? agent.label : '';
    }
    return '';
  }

  clearTestAndSchedules = () => {
    if (this.stage.type == 'Assessment') {
      this.selectedContest = null;
    } else if (this.stage.type == 'Online Interview' || this.stage.type == 'Documentation' || this.stage.type == 'Offer' || this.stage.type === 'Offline Interview' || this.stage.type === 'AI Interview') {
      this.selectedForm = null;
      this.formName = this.stage.form?.name || '';
    }
    this.evaluationCriteria = this.stage.evaluation_criteria || '';
    this.selectedAgent = this.stage.ai_agent_uuid || null;
    this.showSummary = true;
  }

  saveStageManageContent = () => {
    this.manageContentLoad = true;
    let payload: any = {
      event_uuid: this.eventId,
      name: this.stage.name,
      type: this.stage.type,
    };
    if (this.stage.type === 'Assessment') {
      payload.contest_uuid = this.selectedContest;
      payload.email_template_id = this.selectedMailTemplateId?.id || this.stage.email_template?.id;
      payload.is_walk_in = this.isWalkIn;
    } else if (this.stage.type === 'Online Interview' || this.stage.type === 'Documentation' || this.stage.type === 'Offer' || this.stage.type === 'Offline Interview' || this.stage.type === 'AI Interview') {
      if (this.stage.type !== 'AI Interview' || this.selectedForm) {
        payload.form_uuid = this.selectedForm;
      }
      payload.email_template_id = this.selectedMailTemplateId?.id || this.stage.email_template?.id;
    }
    
    if (this.stage.type === 'AI Interview' || this.stage.type === 'Online Interview' || this.stage.type === 'Offline Interview') {
      if (this.evaluationCriteria && this.evaluationCriteria.trim().length > 0) {
        payload.evaluation_criteria = this.evaluationCriteria.trim();
      }
    }
    
    if (this.stage.type === 'AI Interview') {
      payload.ai_agent = this.selectedAgent || this.stage.ai_agent_uuid;
    }
    
    this.jobServices.updateStageFastApi(this.stage.id, payload).subscribe({
      next: (res) => {
        if(res.status === 200){
          this.globalService.commonGrowl.next({ severity: 'success', summary: 'Success', detail: 'Content updated successfully!' });
          this.isStageUpdate.emit(true);
          this.manageContentLoad = false;
          this.showFormDialog = false;
        }
      },
      error: () => {
        this.isStageUpdate.emit(false);
        this.manageContentLoad = false;
      }
    })
  }

  validateTemplate() {
    const data = this.selectedMailTemplate;
    const template: string = data.templateContent ?? "";
    this.errorPlaceholder = [];
    const placeholdersByType: Record<string, Record<string, string>> = {
      "Assessment": {
        "User": "${full_name}",
        "Test_Link": "${test_link}"
      },
      "Online Interview": {
        "User": "${full_name}",
        "interview_start_date": "${interview_start_time}",
        "interview_end_date": "${interview_end_time}",
        "interview_link": "${interview_link}"
      },
      "Offline Interview": {
        "User": "${full_name}",
        "interview_start_date": "${interview_start_time}",
        "interview_end_date": "${interview_end_time}",
        "interview_venue": "${interview_venue}"
      },
      "Documentation": {
        "User": "${full_name}",
        "document_link": "${document_link}"
      },
      "Offer": {
        "User": "${full_name}",
        "offer_link": "${offer_link}"
      },
      "AI Interview": {
        "User": "${full_name}",
        "interview_start_date": "${interview_start_time}",
        "interview_end_date": "${interview_end_time}",
        "interview_link": "${interview_link}"
      }
    };
    
    const requiredPlaceholders = placeholdersByType[this.stage.type];
    if (requiredPlaceholders) {
      for (const placeholder in requiredPlaceholders) {
        if (!template.includes(requiredPlaceholders[placeholder])) {
          this.errorPlaceholder.push(placeholder);
        }
      }
    }
  }
  clearEmailTemplate() {
    this.selectedMailTemplate = {
      templateContent: "-",
      templateTitle: this.stage.email_template?.name || ''
    };
    this.showMailSummary = true;
  }

  openManageEmail() {
    if (this.stage.email_template?.id) {
      this.selectedMailTemplateId = this.stage.email_template.id;
      this.getSpecificTemplateData(this.stage.email_template.id);
    }
    this.loadEmailTemplates();
    this.showEmailDialog = true;
  }

  closeEmailDialog() {
    this.showEmailDialog = false;
    this.selectedMailTemplateId = null;
    this.errorPlaceholder = [];
  }

  loadEmailTemplates() {
    const stageType = this.stage?.type || 'Others';
    this.emailServices.getTemplatesFastApi('', stageType).subscribe({
      next: (response) => {
        if (response.status === 200) {
          let templateList = response.body.email_templates ? response.body.email_templates : [];
          this.EmailTemplateOptions = templateList.map((item: any) => ({
            id: item.id,
            isEditable: item.is_editable,
            name: item.name,
          }));
          if (this.stage.email_template?.id) {
            const match = this.EmailTemplateOptions.find((t: any) => t.id === this.stage.email_template.id);
            if (match) {
              this.selectedMailTemplateId = match;
            }
          }
        }
      },
      error: (_err) => {
        console.error('Error fetching email templates:', _err);
      }
    });
  }
  
  async getSelectedMailTemplate(event: any){
    await this.getSpecificTemplateData(event);
    this.validateTemplate();
  }
  async getSpecificTemplateData(template: any,): Promise<void> {
    const templateId = typeof template === 'object' ? template?.id : template;
    if (templateId) {
      return new Promise((resolve, reject) => {
        this.emailServices.getSpecificTemplateFastApi(templateId).subscribe({
          next: (response) => {
            if (response.status === 200) {
              this.selectedMailTemplate = {
                templateContent: response.body.body,
                templateTitle: response.body.name,
              };
              resolve();
            }
          },
          error: (err) => {
            reject(new Error('Error fetching specific template: ' + err));
          }
        });
      });
    }
  }
  saveEmailTemplate() {
    this.manageTemplateLoad = true;
    let payload:any = {
      event_uuid: this.eventId,
      name: this.stage.name,
      type: this.stage.type,
      email_template_id: this.selectedMailTemplateId.id ? this.selectedMailTemplateId.id : null
    };
    if (this.stage.type === 'Assessment') {
      payload["contest_uuid"] = this.stage.contest.uuid;
    } else if (this.stage.type === 'Online Interview' || this.stage.type === 'Documentation' || this.stage.type === 'Offer' || this.stage.type === 'Offline Interview' || this.stage.type === 'AI Interview') {
      payload.form_uuid = this.stage.form.uuid;
    }
    
    if (this.stage.type === 'AI Interview' || this.stage.type === 'Online Interview' || this.stage.type === 'Offline Interview') {
      if (this.evaluationCriteria && this.evaluationCriteria.trim().length > 0) {
        payload.evaluation_criteria = this.evaluationCriteria.trim();
      }
    }
    
    if (this.stage.type === 'AI Interview') {
      payload.ai_agent = this.selectedAgent || this.stage.ai_agent_uuid;
    }
    
    this.jobServices.updateStageFastApi(this.stage.id, payload).subscribe({
      next: (res) => {
        if(res.status === 200){
        this.globalService.commonGrowl.next({ severity: 'success', summary: 'Success', detail: 'Template updated successfully!' });
        this.isStageUpdate.emit(true);
        this.manageTemplateLoad = false;
        this.showEmailDialog = false;
        }
      },
      error: () => {
        this.isStageUpdate.emit(false);
        this.manageTemplateLoad = false;
      }
    })
  }
  openManageSchedule = () => {
    if(this.stage.type === 'Assessment'){
      this.selectedContest = this.stage.contest?.uuid || null;
    } else if (this.stage.type === 'Online Interview' || this.stage.type === 'Offline Interview' || this.stage.type === 'AI Interview') {
      this.selectedForm = this.stage.form?.uuid || null;
      this.evaluationCriteria = this.stage.evaluation_criteria || '';
      if (this.stage.type === 'AI Interview') {
        this.selectedAgent = this.stage.ai_agent_uuid || null;
        this.loadAgents();
      }
    } else if (this.stage.type === 'Documentation') {
      this.selectedForm = this.stage.form?.uuid || null;
    } else if (this.stage.type === 'Offer') {
      this.selectedForm = this.stage.form?.uuid || null;
    }
    this.loadEmailTemplates();
    if (this.stage.email_template?.id) {
      this.selectedMailTemplateId = this.stage.email_template.id;
      this.getSpecificTemplateData(this.stage.email_template.id);
    }
    this.showFormDialog = true;
  }

  closeFormDialog() {
    this.showFormDialog = false;
    this.selectedMailTemplateId = null;
    this.errorPlaceholder = [];
  }

  formatTestStartDate(dateString: string): string {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      const format = this.dateFormat || 'dd-MM-yyyy';
      return this.datePipe.transform(date, format) || '';
    } catch (error) {
      return '';
    }
  }
}
